export const FAQ_INFO = 'FAQ_INFO';
export const FAQ_INFO_SUCCESS = 'FAQ_INFO_SUCCESS';
export const FAQ_INFO_FAIL = 'FAQ_INFO_FAIL';
export const FAQ_WATCHED = 'FAQ_WATCHED';
export const FAQ_ANSWER_LIKED = 'FAQ_ANSWER_LIKED';
export const FAQ_ANSWER_LIKED_SUCCESS = 'FAQ_ANSWER_LIKED_SUCCESS';
